<template>
  <div class="team-list">
    <Header 
      title="TIMES" 
    ></Header>
      <!-- firstButtonLabel="Criar um time"
      :firstButtonRoute="{ name: 'TeamCreate' }"
      firstButtonVariant="primary" -->
    <div class="container">

      <form class="filterTeams" v-on:submit.prevent="true">
        <b-form-input type="search"
          maxlength="50" v-model="q" placeholder="digite o nome do time para filtrar" />
        <b-input-group-text slot="append" v-if="typing">
          <i class="fas fa-spinner"></i>
        </b-input-group-text>
      </form>

      <div class="team-list">
        <TeamCard :team="team" v-for="team in teams" :key="team.id"></TeamCard>
      </div>
      <div class="no-results" v-if="teams.length == 0">
        <h4>nenhum time encontrado para sua busca</h4>
      </div>

      <b-pagination size="sm" @change="changePage" align="center" :total-rows="totalRecords" v-model="page" :per-page="perPage">
      </b-pagination>

    </div>
  </div>
</template>

<script>
import TeamCard from '@/components/TeamCard'
import Header from '@/components/Header'
import _ from 'lodash'
export default {
  name: 'TeamSingle',
  metaInfo: {
    title: 'Times'
  },
  data () {
    return {
      teams: [],
      q: '',
      page: 1,
      perPage: 0,
      totalRecords: 0
    }
  },
  watch: {
    q: _.debounce(function(newValue) {
      this.q = newValue
      this.page = 1
      this.loadRecords()

      let params = new URLSearchParams(location.search)
      params.set('q', this.q)
      window.history.replaceState({}, '', `${location.pathname}?${params}`)
    }, 350),
    page: function(newValue) {
      const params = new URLSearchParams(location.search)
      params.set('page', newValue)
      window.history.replaceState({}, '', `${location.pathname}?${params}`)
    }
  },
  methods: {
    initialize() {
      let params = new URLSearchParams(location.search)
      if(params.get('page'))
        this.page = params.get('page')
      if(params.get('q'))
        this.q = params.get('q')
      this.loadRecords()
    },
    loadRecords() {
      this.$http
        .get(`teams.json?page=${this.page}&q[name_or_tag_or_slug_or_about_cont]=${this.q}`)
        .then(response => {
          this.teams = response.data.records
          this.totalRecords = response.data.total_records
          this.perPage = response.data.per_page
        })
    },
    changePage(page) {
      this.page = page
      this.loadRecords()
    }
  },
  mounted () {
    this.initialize()
  },
  components: {
    TeamCard,
    Header
  }
}
</script>

<style lang="sass" scoped>
.team-list
  display: flex
  flex-wrap: wrap
  justify-content: space-between
  .team-card
    margin-bottom: 20px
form.filterTeams
  margin: 0 0 40px  
</style>
